import $ from 'jquery';
import fetch from 'utils/fetch';
import React from 'react';
import { renderCheckboxList, renderList } from 'utils/async-list';
import { Column } from 'react-virtualized';
import { withReferer } from 'plugins/contextual-back';
import renderLines from './lines';
import { renderCaseCustomer, renderAmount } from 'modules/saas/common/columns';

export function detail() {
  renderLines();
}

// TODO: Add support for load next URL
export function list(ctx) {
  const caseId = ctx.params.id;
  const referer = `/pco-manager/cases/${caseId}/estimates`;

  const rowClickedUrl = id =>
    withReferer(`/pco-manager/estimates/${id}`, referer);
  const loadNextUrl = `/pco-manager/cases/${caseId}/estimates.json`;

  renderCheckboxList(rowClickedUrl, loadNextUrl, renderColumns);
}

export function listToPrepare(ctx) {
  const referer = `/pco-manager/workflow/estimates/toprepare`;

  const rowClickedUrl = id =>
    withReferer(`/pco-manager/estimates/${id}`, referer);
  const loadNextUrl = `/pco-manager/workflow/estimates/toprepare.json`;

  renderList(rowClickedUrl, loadNextUrl, renderToPrepareColumns);
}

export function listWaiting(ctx) {
  const referer = `/pco-manager/workflow/estimates/waiting`;

  const rowClickedUrl = id =>
    withReferer(`/pco-manager/estimates/${id}`, referer);
  const loadNextUrl = `/pco-manager/workflow/estimates/waiting.json`;

  renderCheckboxList(rowClickedUrl, loadNextUrl, renderWaitingColumns);
}

export function renderStatus({ cellData }) {
  let label, title;

  switch (cellData) {
    case 'TO_PREPARE':
      label = 'ui red labels';
      title = 'A préparer';
      break;
    case 'ISSUED':
      label = 'ui yellow labels';
      title = 'Généré';
      break;
    case 'ACCEPTED':
      label = 'ui green labels';
      title = 'Accepté';
      break;
    case 'REFUSED':
      label = 'ui labels';
      title = 'Refusé';
      break;
    default:
      break;
  }

  if (label && title) {
    return (
      <div className={label}>
        <span className="ui label">{title}</span>
      </div>
    );
  }

  return null;
}

function renderColumns(width) {
  return [
    <Column key="number" dataKey="number" width={width / 16 * 3} label="N°" />,
    <Column
      key="status"
      dataKey="status"
      width={width / 16 * 3}
      cellRenderer={renderStatus}
      label="Statut"
    />,
    <Column
      key="issued_at"
      dataKey="issued_at"
      width={width / 16 * 7}
      label="Date d&#39;émission"
    />,
    <Column
      key="amount"
      dataKey="amount"
      headerClassName="right aligned"
      className="right aligned"
      width={width / 16 * 3}
      cellRenderer={renderAmount}
      label="Montant"
    />,
  ];
}

function renderToPrepareColumns(width) {
  return [
    <Column
      key="customer"
      dataKey="customer"
      width={width / 16 * 10}
      cellRenderer={renderCaseCustomer}
      label="Chantier"
    />,
    <Column
      key="amount"
      dataKey="amount"
      headerClassName="right aligned"
      className="right aligned"
      width={width / 16 * 6}
      cellRenderer={renderAmount}
      label="Montant HT"
    />,
  ];
}

function renderAction({ rowData }) {
  const id = rowData.id;

  const onClick = evt => {
    evt.stopPropagation();

    const $button = $(evt.currentTarget);
    const action = $button.attr('data-action');
    const method = $button.attr('data-method');
    const data = [id];

    fetch(action, {
      method: method,
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(
      res => window.location.replace(res.url),
      err => {
        console.log('Error attempting to save estimate', err);
      }
    );
  };

  const renderButton = (
    <div className="ui buttons">
      <a
        className="ui basic green button"
        onClick={onClick}
        data-action="/pco-manager/workflow/estimates/accept"
        data-method="PUT"
      >
        <i className="checkmark icon" />
        Accepter
      </a>
      <a
        className="ui basic grey button"
        onClick={onClick}
        data-action="/pco-manager/workflow/estimates/refuse"
        data-method="PUT"
      >
        <i className="remove icon" />
        Refuser
      </a>
    </div>
  );

  return renderButton;
}

function renderWaitingColumns(width) {
  return [
    <Column
      key="id"
      dataKey="id"
      width={width / 16 * 4}
      cellRenderer={renderAction}
      disableSort
      label="Action"
    />,
    <Column
      key="customer"
      dataKey="customer"
      width={width / 16 * 7}
      cellRenderer={renderCaseCustomer}
      label="Chantier"
    />,
    <Column key="number" dataKey="number" width={width / 16 * 3} label="N°" />,
    <Column
      key="amount"
      dataKey="amount"
      headerClassName="right aligned"
      className="right aligned"
      width={width / 16 * 2}
      cellRenderer={renderAmount}
      label="Montant HT"
    />,
  ];
}



// WEBPACK FOOTER //
// ./src/modules/saas/estimates/index.js